import { memo } from 'react';

import { Button } from '@/shadcn/button';

import type { WorkflowGroupsQueryQuery } from '@/apollo/graphql';
import TraceIconSpinner from '@/components/ui/traceIconSpinner';
import { TestId } from '@/types/testId';
import { GroupCard } from './groupCard/groupCard';

type Props = {
  isLoading: boolean;
  workflow: WorkflowGroupsQueryQuery['workflowByRowId'];
  fetchMoreGroups: () => void;
  hasFilters: boolean;
};

export const GroupsList = memo(
  ({ isLoading, workflow, fetchMoreGroups, hasFilters }: Props) => {
    if (isLoading) return <TraceIconSpinner />;
    if (!workflow) return null;

    const groups = workflow.groups.nodes;
    const nbGroups = workflow.groups.totalCount;
    const pageInfo = workflow.groups.pageInfo;

    return (
      <div className="flex flex-col gap-2 px-5 py-4">
        {nbGroups ? (
          groups
            .filter(g => !!g)
            .map(group => <GroupCard group={group} key={group.rowId} />)
        ) : (
          <div className="py-1.5 text-muted-foreground text-sm">
            {`No groups to display here${
              hasFilters ? ' (a filter is being applied)' : ''
            }`}
          </div>
        )}
        {isLoading ? (
          <TraceIconSpinner className="mt-4 size-[34px]" />
        ) : (
          pageInfo?.hasNextPage && (
            <Button
              className="mt-3 h-12 w-full"
              data-testid={TestId.WorkflowGroups.GroupsList.LoadMoreButton}
              onClick={fetchMoreGroups}
              variant="outline"
            >
              Show more groups
            </Button>
          )
        )}
      </div>
    );
  }
);
